import { SvgIcon, SvgIconProps } from "@mui/material";

const ArrowIconRight = (props: SvgIconProps) => (
  <SvgIcon
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M26 20H14M26 20L22.5 16.5M26 20L22.5 23.5"
      stroke={props?.fill || "#000000"}
    />
  </SvgIcon>
);

export default ArrowIconRight;
